import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { MessagesTitles, MessagesGeneral, MessagesDates } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { ProformaService } from 'app/services/operaciones/proforma/proforma.service';
import { environment } from 'environments/environment';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-lista-documentos',
  templateUrl: './lista-documentos.component.html',
  styleUrls: ['./lista-documentos.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaDocumentosComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  ruc = new FormControl();
  rucAdq = new FormControl();
  readonly TIPO_OPERACION = 'PO';
  idProv = "";
  idAdq = "";
  RUC_PROV: string;
  RUC_ADQ: string;
  Canal: string = "B";
  FFinal: Date = new Date();
  FInicial: Date = new Date();
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  docNegociables: any = [];
  loading: boolean;
  dataSource: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns: string[] = ['checked', 'NombreComercialProv', 'NombreComercialAdq', 'TipoMoneda', 'VNPP', 'Cantidad'];
  subLista: Subscription[] = [];
  subProforma: Subscription = new Subscription();

  constructor(
    private proformaService: ProformaService,
    private router: Router,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
    this.ListadoProformaFiltros();
  }

  ngOnDestroy(): void {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  ListadoProformaFiltros() {    
    this.loading = true;

    if (this.ruc.value == '') {
      this.idProv = '';
    }
    if (this.rucAdq.value == '') {
      this.idAdq = '';
    }

    this.subProforma = this.proformaService.ObtenerListaProforma(this.idProv, this.idAdq, this.TIPO_OPERACION).subscribe(
      res => {
        this.docNegociables = res;
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },
      err => {
        this.loading = false;
        Swal.fire({
          title: "Datos incompletos",
          text: "Coordine con el departamento de contabilidad.",
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subProforma);
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentessArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdq = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProv = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges.pipe(
      startWith(""),
      map(state =>
        state ? this._filterProv(state) : this.proveedoresArr.slice()
      )
    );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges.pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentessArr.slice()
      )
    );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerRucProv(termino: string) {
    this.idProv = termino;
  }

  obtenerRucAdq(termino: string) {
    this.idAdq = termino;
  }

  crearPropuestaOperacion(elemento: any) {
    this.loginService.clickGuard = true;
    this.proformaService.datosProforma = elemento;
    this.router.navigate(["/operaciones/propuesta-operacion/nuevo"]);
  }

}
